// src/hooks/useJobs.ts
import { useQuery } from "@tanstack/react-query";
import { getAllJobs } from "../services/jobsServices";

export const useJobs = ({ lastId, limit = 10, status = null } = {}) => {
  return useQuery({
    queryKey: ["jobs", lastId, limit, status],
    queryFn: () => getAllJobs({ lastId, limit, status }),
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
  });
};
